import { render, staticRenderFns } from "./ConsAgendamentos.vue?vue&type=template&id=8c17a6ae"
import script from "./ConsAgendamentos.vue?vue&type=script&lang=js"
export * from "./ConsAgendamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports